import React from 'react'
import { StyledSelect } from './styles'

const FormSelect = React.forwardRef(({
  placeholder,
  onChangeVal,
  options,
  dispField,
  valField,
  ...rest
}, ref) => (
    <StyledSelect onChange={e => onChangeVal(e)} ref={ref} {...rest}>
      <option value={'-'} disabled>{placeholder}</option>
      {options.map((opt, i) => {
        return (
          <option value={valField === 'seam' || valField === 'year' ? opt : opt[valField]} key={i}>
            {valField === 'seam' || valField === 'year' ? opt : opt[dispField]}
          </option>
        )
      })}
    </StyledSelect>
  ))

export default FormSelect